
module.exports = {
    myHost: {
    //    'host':'https://api-gfc.catchbangladesh.com',
       'host':'https://api-staging-gfc.catchbangladesh.com',
    //    'host':'http://192.168.68.110:8080',
    }
};
